import LogRocket from "logrocket";

export function captureMessage(message, options = {}) {
    const orderId = options.orderId ?? window.sessionStorage.getItem('ORDER_ID');
    LogRocket.captureMessage(`${message} orderID: ${orderId}`, options);
}

/**
 *
 * @param {Error} error
 * @param {import("logrocket").ICaptureOptions}options
 */
export function captureException(error, options = {}) {
    const message = error.message ?? 'Error occured';
    // Send slack notif before capturing exception
    captureMessage(message, options);
    // Save error in LR
    LogRocket.captureException(error, options);
  }
